module.exports = "/wwwroot/img/cc-by.svg?ver=d9e49fe4";